/* unplugin-vue-components disabled */import script from "./data1.vue?vue&type=script&setup=true&lang=js"
export * from "./data1.vue?vue&type=script&setup=true&lang=js"

import "./data1.vue?vue&type=style&index=0&id=325970a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325970a2"]])

export default __exports__